import { render, staticRenderFns } from "./user-task-icon-component.vue?vue&type=template&id=6b14323e&scoped=true"
import script from "./user-task-icon-component.ts?vue&type=script&lang=ts&external"
export * from "./user-task-icon-component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-task-icon-component.scss?vue&type=style&index=0&id=6b14323e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b14323e",
  null
  
)

export default component.exports